import React from "react";
import "./Furits.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClock,
  faEnvelope,
  faArrowAltCircleLeft,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import Contact from "../../Components/LandingPageSections/Contact";
import Footer from "../../Components/Layout/Footer";
import { Link } from "react-router-dom";

function Intro() {
  return (
    <div className="furits">
      <div className="blog-logo">
        <Link to="/">
          <img src="/img/logo1.png" width="30px" height="20px"></img>
        </Link>
      </div>

      <div className="furits_flex">
        <div className="furits_apple">
          <img src="/img/blog22.png"></img>
          <h2 className="furit_heading">Welcome to SecondLookOrtho!</h2>
          <div className="shoulde_process_f">
            <div className="shoudle_logo_f">
              <img src="img/second-blog.png"></img>
              <span className="bolg_card_f">SecondlookOrtho</span>
            </div>
            <div className="date">
              <div className="months_date">
                <FontAwesomeIcon icon={faClock} />
                <span className="spandate">8 months ago</span>
              </div>
              <div className="months_date">
                <FontAwesomeIcon icon={faEnvelope} />
                <span className="mass-num">2</span>
              </div>
            </div>
          </div>
          <div className="furit_para">
            Wellcom to SecondlookOrtho!<br></br>
            <br></br>
            Thank you for visiting our website. In addition to offering
            individual advice and consultations regarding your orthopedic
            injuries and treatment, we hope to offer guidance and educational
            information through these monthly blogs. We will address all
            different topics related to orthopedics regarding surgery,
            rehabilitation, injuries, treatments, etc. I encourage you to ask us
            questions that we will address through these monthly blogs. This
            information is free to you. We are here to help you, encourage you,
            and guide you to get better and feel better.
            <br></br>
            <br></br>Sincerely, <br></br>
            <br></br>SecondLookOrtho Team
          </div>
          <div className="blog_post">
            <div className="icon">
              <FontAwesomeIcon icon={faArrowAltCircleLeft} />
            </div>
            <div className="text_f">
              <strong className="text_primery">Previous Post </strong>
              <h6>Welcome to SecondLookOrtho!</h6>
            </div>
          </div>
          <div className="comonts_post">
            Post Comments<span>(1)</span>
          </div>
          <div className="profle_sec">
            <div className="profl_img">
              <img src="/img/user.svg"></img>
            </div>
            <div className="profile_name">
              <div className="pro-nam">Dev</div>
              <div className="pro-date">Nov 2021</div>
            </div>
          </div>
          <div className="profle_sec">
            <div className="profl_img">
              <img src="/img/user.svg"></img>
            </div>
            <div className="profile_name">
              <div className="pro-nam">Rehman</div>
              <div className="pro-date">July 2021</div>
            </div>
          </div>
          <p class="into_p">
            Hello, I'm now 177cm My dream height is 188cm But is it possible? If
            i'll get limb leghting surgery?
          </p>
          <div className="leave_comment">Leave a reply</div>
          <div className="comment_input">
            <div className="comment_input1">
              <input
                name="Name"
                className="comment_in"
                // name="Name"
                placeholder="
              Name"
              />
            </div>
            <div className="comment_input2">
              <input
                name="Email"
                type="text"
                className="comment_in"
                placeholder="Email(Will not be published)"
              />
            </div>
            <div className="massege_furit">
              <textarea
                className="Massage_area_f"
                placeholder=" Type your Comment"
              ></textarea>
            </div>
          </div>
          <button className="furit_btn">Submit Comment</button>
        </div>
        <div className="furits_div2">
          <header className="widget-header">
            <h6 className="weight-header-h3">Latest Posts</h6>
          </header>
          <div className="blog-posts">
            <div className="weight-let-post">
              <div className="weight-divs">
                <div className="apple-weight">
                  <img src="/img/apple-orange.jpg"></img>
                </div>
                <div className="weight-tittle">
                  All Surgeries are not created equal!
                </div>
              </div>
              <div className="months_date-weight">
                <FontAwesomeIcon icon={faEnvelope} />
                <span className="mass-num">6</span>
              </div>
            </div>
            <div className="weight-let-post">
              <div className="weight-divs">
                <div className="apple-weight">
                  <img src="/img/blog22.png"></img>
                </div>
                <div className="weight-tittle">Welcome to SecondLookOrtho!</div>
              </div>
              <div className="months_date-weight">
                <FontAwesomeIcon icon={faEnvelope} />
                <span className="mass-num">6</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Contact />
      <Footer />
    </div>
  );
}
export default Intro;
